/* eslint-disable */
import { compose, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import CartController from './CartController';
import { toggleSidebar } from '../Layout/LayoutState';

export default compose(
  withRouter,
  connect(
    (state) => ({
      isSidebarOpened: state.layout.isSidebarOpened,
      cartFieldIds: state.cartReducer.filesId? state.cartReducer.filesId:[],
    }),
    { toggleSidebar },
  ),
)(CartController);
